/**
 * api接口统一管理
 */
import { getRequest, postJsonRequest, postRequest, jsonpRequest } from './http'

let api = location.origin + '/ibook'
console.log(process.env.NODE_ENV, location.href)
if (process.env.NODE_ENV === 'development' || location.href.indexOf('127.') >= 0 || location.href.indexOf('localhost') >= 0) {
  api = 'http://iclass.zxxk.com/ibook'
  console.log('本地接口要指定域名', api)
}

const classSpace = "/class-space"

export const userApi = {
  login: () => {
    let url = api + '/users/user'
    return getRequest(url, {})
  },
  logout: () => {
    let url = api + '/users/logout'
    window.location.href = url
  },
  message: () => {
    let url = api + '/message/unread'
    return getRequest(url, {})
  }
}

export const navigationApi = {
  getPrimaryData: () => {
    return getRequest(api + '/index/menus', {})
  }
}

export const classSpaceApi = {
  getTeacherSubject: () => {
    return getRequest(api + classSpace + '/teacher-subject', {})
  },
  getShareClass: (subjectId) => {
    return getRequest(api + classSpace + '/share-class', { subjectId: subjectId })
  },
  getFileList: (params) => {
    let url = api + classSpace + '/query'
    if (params.role === 'STUDENT') {
      url = api + classSpace + '/student/query'
    }
    return postJsonRequest(url, params)
  },
  // 新建文件夹
  saveFolder: (params) => {
    return postJsonRequest(api + classSpace + '/save-folder', params)
  },
  // 修改文件夹名称
  changeFileName: (params) => {
    return postJsonRequest(api + classSpace + '/change-fileName', params)
  },
  // 删除文件夹
  deleteFile: (params) => {
    return postJsonRequest(api + classSpace + '/delete-file', params)
  },
  // 切换班级
  changeClass: (params) => {
    return postJsonRequest(api + classSpace + '/change-class', params)
  },
  // 获取移动到的文件列表
  getFolderList: (params) => {
    return getRequest(api + classSpace + '/share-folderList?subjectId=' + params.subjectId + "&parentId=" + params.parentId, {})
  },
  getNewFolderList: (params) => {
    return getRequest(api + classSpace + '/folderList?subjectId=' + params.subjectId + "&parentId=" + params.parentId, {})
  },
  // 移动
  moveFile: (params) => {
    return postJsonRequest(api + classSpace + '/move-file', params)
  },
  //上传文件
  uploadFile: (params) => {
    return postRequest(api + classSpace + '/upload', params)
  },
  //批量上传文件
  uploadBatchFile: (params) => {
    return postJsonRequest(api + classSpace + '/batch-upload', JSON.stringify(params))
  },
  // 下载文件
  downloadFile: (archiveId) => {
    return getRequest(api + '/resource/DOCUMENT-' + archiveId + '/download-url?provider=I_CLASS&login-mode=NORMAL_USER')
  },
  // 分享到班级空间
  canShare: (subjectId) => {
    return getRequest(api + classSpace + '/can-share?subjectId=' + subjectId, {})
  },
  // 分享到班级空间
  share: (params) => {
    return postJsonRequest(api + classSpace + '/share', params)
  },
  // provider WPS_CLOUD \ OFFICE_WEB_365
  getDocumentCloudServiceUrl: function (documentId, provider, editable, bizId) {
    const params = {
      document_cloud_provider: provider,
      full: true,
      editable: editable,
      provider: 'I_CLASS',
      bizId: bizId
    }
    const url = '/ibook/resources/DOCUMENT-' + documentId + '/cloud-service'
    return getRequest(url, params)
  },
  // 通过文件Id获取指定文件详情
  getClassSpaceFileById: (fileId) => {
    return getRequest(api + classSpace + '/' + fileId, {})
  },
  calcUserAction: function (params) {
    // 统计用户行为
    return postJsonRequest('/ibook/class-space/user-action ', params)
  }
}

export const helpApi = {
  //帮助中心
  getFaqs: (type) => {
    // 获取指定类别的FAQ的主题列表
    return getRequest(api + '/faq/topics/' + type)
  },
  getAnswer: (id) => {
    return getRequest(api + '/faq/' + id + '/answer')
  }
}

export const downloadCenterApi = {
  //下载中心
  getAllOnlineAppDownload: () => {
    return getRequest(api + '/public-api/allAppDownload')
  },
  getAppDownload: (identity) => {
    let url = api + '/app-download/jsonp/getAppDownload'
    return jsonpRequest(url, { identity: identity })
  },
  gePartDownload: () => {
    let url = api + '/public-api/filtered-online-App-Download'
    return getRequest(url)
  }
}

export const controlApi = {
  selectControlPresetUrl: () => {
    return getRequest(api + '/pad/control/preset/url/select')
  }
}


export const teacherHomeApi = {
  getBanners: (location = 4) => {
    return getRequest(api + '/vpi/statistics/teacher-home-page/banner', { location: location })
  },
  getTasks: () => {
    return getRequest(api + '/vpi/statistics/teacher-home-page/task-list')
  },
  getTeacherNews: () => {
    return postJsonRequest(api + '/vpi/statistics/teacher-home-page/user-news/_search', { currentPage: 1, pageSize: 10 })
  },
  getStudentNews: (params) => {
    return postJsonRequest(api + '/vpi/statistics/teacher-home-page/student-news/_search', params)
  },
  getRanks: () => {
    const date = new Date()
    const month = (date.getMonth() + 1)
    const prefix = date.getFullYear() + '.' + month + '.'
    const params = {
      beginTime: prefix + '01',
      endTime: prefix + date.getDate()
    }
    return postJsonRequest(api + '/vpi/statistics/teacher-home-page/rank', params)
  },
  checkGuide: (guideId = 'ekt-teacher-idx-1', onlyQuery = false, expiredDate = null) => {
    return getRequest(api + '/vpi/guide/show', { guideId, onlyQuery, expiredDate })
  },
  setGuideTime: (guideId, expiredDate) => {
    return postJsonRequest(api + '/vpi/guide/repeated-time?guideId=' + guideId + '&expiredDate=' + expiredDate, {})
  },
  getActivityClassList: function () {
    const url = '/gw/self/study/api/statistics/student-news-page/class'
    return getRequest(url, {})
  },
  getActivitySubjects: function () {
    const url = '/gw/self/study/api/statistics/student-news-page/subject'
    return getRequest(url, {})
  },
  getActivityStatistics: function (subjectId, classId, topN = 6) {
    const params = { topN }
    if (subjectId > 0) {
      params.subjectId = subjectId
    }
    if (classId > 0) {
      params.classId = classId
    }
    const url = '/gw/self/study/api/statistics/student-news-page/_query'
    return postRequest(url, params)
  },
  // 获取学段学科
  getTeachInfo: () => {
    const url = '/ibook/user-base-api/teaching-info/teacher'
    return getRequest(url, {})
  },
  getCurrentCourse: () => {
    const url = '/gw/training/api/user/cache/course'
    return getRequest(url, {})
  },
  postCurrentCourse: (courseId) => {
    const url = '/gw/training/api/user/cache/course/' + courseId
    return postRequest(url, {})
  }
}

